/** @format */

import React, { useState, useEffect } from "react";
import usePermissions from "../../../../components/permissions/permission";

const SLAB = () => {
  const { hasPermission } = usePermissions();
  const [employeeId, setEmployeeId] = useState("");
  const [payrollData, setPayrollData] = useState([]);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filterAddedDate, setFilterAddedDate] = useState("");
  const { REACT_APP_API_ENDPOINT } = process.env;

  const fetchSLABIncentives = async () => {
    try {
      const response = await fetch(
        `${REACT_APP_API_ENDPOINT}/v1/hris/payroll/slab-incentives`
      );
      const data = await response.json();
      setPayrollData(data);
      console.log("payrolldata:", data);
    } catch (error) {
      console.error("Error fetching SLAB incentives:", error);
      setErrorMessage({
        fetch: "Failed to fetch SLAB incentives. Please try again later.",
      });
    }
  };

  useEffect(() => {
    fetchSLABIncentives();
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
    setErrorMessage({});
  };

  const handleCalculateSubmit = async () => {
    const body = {
      month: parseInt(month),
      year: parseInt(year),
    };

    try {
      const response = await fetch(
        `${REACT_APP_API_ENDPOINT}/v1/hris/payroll/calculate-slab-incentive`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );
      const data = await response.json();

      if (response.ok) {
        setIsModalOpen(false);
      } else {
        console.error(data.error || data.message);
      }
    } catch (error) {
      console.error("Error calculating SLAB incentive:", error);
    }
  };
  const filteredData = payrollData.filter(
    (item) =>
      (!filterMonth || item.month.toString() === filterMonth) &&
      (!filterYear || item.year.toString() === filterYear)
  );

  return (
    <div className="font-sans bg-background overflow-auto h-screen">
      <div>
        <p className="mt-6 ml-6 text-headerColor text-[30px] font-semibold">
          Calculate SLAB
        </p>
      </div>
      <div className="flex justify-between items-center ml-10">
        <div className="flex flex-col">
          <select
            id="monthSelect"
            name="month"
            value={filterMonth}
            onChange={(e) => setFilterMonth(e.target.value)}
            autoComplete="off"
            className="w-[300px] h-10 rounded-[73px] py-1.5 bg-white placeholder-white sm:text-sm px-2 font-sans mb-3"
          >
            <option value="" className="font-sans-bold">
              Filter By Month
            </option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
          <select
            id="yearSelect"
            name="year"
            value={filterYear}
            onChange={(e) => setFilterYear(e.target.value)}
            autoComplete="off"
            className="w-[300px] h-10 rounded-[73px] py-1.5 bg-white placeholder-white sm:text-sm px-2 font-sans"
          >
            <option value="" className="font-sans-bold">
              Filter By Year
            </option>
            {Array.from({ length: 10 }, (_, i) => {
              const year = new Date().getFullYear() - i;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </select>
        </div>
        <div className="bg-white rounded-[22px] h-[189px] w-[430px] p-5 mb-5 mr-10">
          <div className="text-[#797C80] font-bold text-[29px] mb-5">
            <p>Calculate SLAB Incentive</p>
          </div>
          <div className="flex items-center justify-between">
            <label
              htmlFor="fileInput"
              className="bg-primary p-2 mt-10 rounded-[32px] text-white cursor-pointer"
              onClick={() => setIsModalOpen(true)}
            >
              + Calculate
            </label>
          </div>
        </div>
      </div>
      <div className="flex flex-col font-sans font-bold ml-6 mt-[50px] rounded-xl">
        <table className="table-auto border-none w-[95%] rounded-2xl border-2">
          <thead>
            <tr className="bg-white rounded-xl">
              <th className="text-primary px-4 py-2">Month</th>
              <th className="text-primary px-4 py-2">Year</th>
              <th className="text-primary px-4 py-2">SLAB Value</th>
              <th className="text-primary px-4 py-2">Calculate Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, index) => (
              <tr key={item.id}>
                <td className="bg-white px-4 py-2 text-center">{item.month}</td>
                <td className="bg-white px-4 py-2 text-center">{item.year}</td>
                <td className="bg-white px-4 py-2 text-center">
                  {item.slab_value}
                </td>
                <td className="bg-white px-4 py-2 text-center">
                  {new Date(item.calculated_date).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {isModalOpen && (
        <div className="fixed top-0 left-0 h-full flex items-center justify-center bg-black bg-opacity-50 z-50 w-full">
          <div className="bg-[#F3F8FF] p-6 rounded-[40px]">
            <div className="mb-6 items-center justify-center">
              <p className="font-sans text-[32px] font-bold text-center">
                Calculate SLAB Incentive
              </p>
              <div className="mt-5 flex flex-col">
                <div className="flex flex-row items-center">
                  <div>
                    <p className="font-sans font-semibold">Month :</p>
                  </div>
                  <div className="ml-6">
                    <input
                      type="number"
                      min="1"
                      max="12"
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                      className="w-[300px] h-10 rounded-[73px] py-1.5 bg-white placeholder-white sm:text-sm px-2 font-sans"
                    />
                    {errorMessage.month && (
                      <p className="text-red-500 text-sm mt-1">
                        {errorMessage.month}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-row items-center mt-4">
                  <div>
                    <p className="font-sans font-semibold">Year :</p>
                  </div>
                  <div className="ml-6">
                    <input
                      type="number"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      className="w-[300px] h-10 rounded-[73px] py-1.5 bg-white placeholder-white sm:text-sm px-2 font-sans"
                    />
                    {errorMessage.year && (
                      <p className="text-red-500 text-sm mt-1">
                        {errorMessage.year}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex justify-center mt-5 space-x-3">
                <button
                  className="bg-primary p-2 rounded-[22px] text-white"
                  onClick={handleCalculateSubmit}
                >
                  Submit
                </button>
                <button
                  className="bg-gray-500 p-2 rounded-[22px] text-white"
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SLAB;
